import {
  Routes,
  Route,
  Outlet,
  Link,
  useNavigate,
  useLocation,
} from "react-router-dom";
import Root from "./routes/Root.tsx";
import Application from "./routes/Application.tsx";
import {
  ApplicationLogs,
  ErrorIntervalLogs,
  IntervalLogs,
  TraceIdLogs,
  WarnIntervalLogs,
} from "./routes/ApplicationLogs.tsx";
import "./App.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome } from "@fortawesome/free-solid-svg-icons";

import NTELogo from "./assets/NTELogo.svg";

export default function App() {
  const navigate = useNavigate();
  const location = useLocation();
  const isHomePage = location.pathname === "/";

  return (
    <div>
      <nav className="navbar navbar-expand-lg navbar-dark bg-dark mb-4">
        <div className="container">
          <Link to="/" className="navbar-brand">
            <img
              style={{ maxHeight: "auto", maxWidth: "100px" }}
              src={NTELogo}
            />
          </Link>

          <div className="ms-auto">
            {!isHomePage && (
              <button
                className="btn btn-outline-light me-2"
                onClick={() => navigate("/")}
              >
                <FontAwesomeIcon icon={faHome} className="me-1" /> Hjem
              </button>
            )}
          </div>
        </div>
      </nav>
      <div className="container">
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Root />} />
            <Route path="/apps/:appId" element={<Application />} />
            <Route path="/apps/:appId/logs" element={<ApplicationLogs />} />
            <Route
              path="/apps/:appId/logs/:query"
              element={<ApplicationLogs />}
            />
            <Route
              path="/apps/:appId/logs/interval/:query"
              element={<IntervalLogs />}
            />
            <Route
              path="/apps/:appId/logs/errors/interval/:query"
              element={<ErrorIntervalLogs />}
            />
            <Route
              path="/apps/:appId/logs/warnings/interval/:query"
              element={<WarnIntervalLogs />}
            />
            <Route path="/logs/traceId/:query" element={<TraceIdLogs />} />
            <Route path="*" element={<NoMatch />} />
          </Route>
        </Routes>
      </div>
    </div>
  );
}

function Layout() {
  return (
    <div>
      <Outlet />
    </div>
  );
}

function NoMatch() {
  return (
    <div>
      <h2>Nothing to see here!</h2>
      <p>
        <Link to="/">Go to the home page</Link>
      </p>
    </div>
  );
}
